// extracted by mini-css-extract-plugin
export default {"panelContainer":"RoutesWrapper_panelContainer__NHpUH","panelContent":"RoutesWrapper_panelContent__hE30U","spinner":"RoutesWrapper_spinner__LxwCg"};